export const normalizeField = (field) => {
	if (!field.label) {
		field.label = field.name;
	}

	if (!field.name) {
		field.name = field.label.replace(/\s/g, "");
	}

	if (!field.id) {
		field.id = field.name;
	}

	if (!field.type) {
		field.type = "text";
	}

	return field;
};

export const populateArray = (array, count, template) => {
	const diff = count - array.length;

	if (diff > 0) {
		for (let i = 0; i < diff; i++) {
			array.push(template);
		}
	}

	if (diff < 0) {
		for (let i = 0; i < Math.abs(diff); i++) {
			array.pop();
		}
	}

	return array;
};
